module.exports = __webpack_public_path__ + "img/fuji.b09a65fb.png";